module.exports = __webpack_public_path__ + "img/29.9.TU.b4423a39.png";